export const docs = 'https://docs.shieldoo.io/';
export const question = 'https://github.com/cloudfieldcz/shieldoo-mesh-docs/issues/new?assignees=&labels=question&template=support-question.md';
export const feature = 'https://github.com/cloudfieldcz/shieldoo-mesh-docs/issues/new?assignees=&labels=enhancement&template=feature_request.md';
export const bug = 'https://github.com/cloudfieldcz/shieldoo-mesh-docs/issues/new?assignees=&labels=bug&template=bug_report.md';
